<template>
<v-container mt-0>
<v-layout row justify-space-between>
    <v-flex xs5>
      <h3>{{user.email}} - Previous Submissions</h3>
     
    </v-flex>
 <v-flex xs7 class="text-xs-right">
 <v-spacer></v-spacer>
 <v-btn to="/content/new"><v-icon >movie</v-icon>&nbsp;Upload Content</v-btn>
 <v-btn  @click="onLogout" style="display:inline-block;">
             <v-icon >exit_to_app</v-icon>
              <span >Logout</span>
             </v-btn>
             
              </v-flex>
               </v-layout>
    
    <p></p>
    <v-layout v-for="content in contents" :key="content.id">
      <v-flex xs12 mb-3>
        <v-card class="card" >
          <v-container fluid >
            <v-layout row >
              <v-flex xs5 sm4 md3>
                <v-card-media 
                  :src="content.imageUrl"
                  height="130px"
                ></v-card-media>
              </v-flex>
              <v-flex xs7 sm8 md9 >
                <v-card-title primary-title class="pt-0">
                <div>
                <h5 class="balck--text  mb-0">{{ content.title}}</h5>
                <div>Artist: {{content.artist }}</div>
                <div>Uploaded: {{ content.date | date }}</div>
                </div>
                 </v-card-title>
                 <v-card-actions  >
                   
                   <app-view-content-details-dialog :videoUrl="content.videoUrl" :imageUrl="content.imageUrl" :content="content"></app-view-content-details-dialog>
                
                   
                  
            
                 </v-card-actions>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  data () {
    return {
      email: '',
      password: '',
      confirmPassword: ''
    }
  },
  created() {
      console.log("USER",this.user);
      //this.$store.dispatch('loadContents')
      this.$store.dispatch('loadUserContents',this.user.id);
     
      this.$store.dispatch('assignUserEmail',this.user.id);
  },
  
  computed: {
    contents () {
       return this.$store.getters.userContents
     },
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  watch: {
    
    user (value) {
      if (value == null && value == undefined) {
        this.$router.push('/')
      }else{
        console.log("HAVE A USER",value);
      }
    }
  },
  methods: {
    onForgot(){
       this.$store.dispatch('forgotPassword', {email: this.email})
    },
    onSignin () {
      console.log('email:', this.email)
      this.$store.dispatch('signUserIn', {email: this.email, password: this.password})
    },
    onDismissed () {
      console.log('Dismissed alert')
      this.$store.dispatch('clearError')
    },
    onLogout () {
      console.log("LOGOUT")
        this.$store.dispatch('logout')
      }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/User/Profile.vue